import React from "react";
import { Icon } from "@folio/stripes/components";
import { useActiveRoles, hasRole, hasAtLeastOneRole, } from "../utils/permissionsUtils";
import { RoleEnum } from "../types/RoleEnum";
import { AccessDenied } from "../components/AccessDenied";
export var RouteGuard = function (_a) {
    var children = _a.children, allowedRoles = _a.allowedRoles, fallbackComponent = _a.fallbackComponent, loadingComponent = _a.loadingComponent;
    var _b = useActiveRoles(), activeRoles = _b.roles, isLoading = _b.isLoading;
    if (isLoading) {
        return (loadingComponent || (React.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            } },
            React.createElement(Icon, { icon: "spinner-ellipsis", size: "large" }))));
    }
    if (!allowedRoles || allowedRoles.length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    if (activeRoles && hasRole(activeRoles, RoleEnum.SUPERUSER)) {
        return React.createElement(React.Fragment, null, children);
    }
    var hasPermission = activeRoles && hasAtLeastOneRole(activeRoles, allowedRoles);
    if (!hasPermission) {
        return fallbackComponent || React.createElement(AccessDenied, null);
    }
    return React.createElement(React.Fragment, null, children);
};
